import Pill, { type PillColor } from '@/shared/components/flip-ui-kit/Pill';
import { type FundingEventType } from '@/shared/graphql/generated/explorer/graphql';

export const fundingEventLabelMap: Record<FundingEventType, string> = {
  FUNDED: 'Funding',
  // TODO(WEB-4016): Update label for on-chain funding events
  FUNDED_ON_CHAIN: 'Funding (on-chain)',
  SLASHED: 'Slashing',
  REDEEMED: 'Redemption',
  REDEMPTION_REQUESTED: 'Redemption Tax',
  REBALANCE: 'Rebalance',
} as const;

const eventColorMap: Record<FundingEventType, PillColor> = {
  FUNDED: 'green',
  // TODO(WEB-4016): Update color for on-chain funding events
  FUNDED_ON_CHAIN: 'green',
  SLASHED: 'red',
  REDEEMED: 'blue',
  REDEMPTION_REQUESTED: 'yellow',
  REBALANCE: 'purple',
};

export function FundingEventBadge({
  eventType,
}: {
  eventType: FundingEventType;
}): React.JSX.Element {
  return <Pill color={eventColorMap[eventType]} text={fundingEventLabelMap[eventType]} />;
}
